<template>
    <modal :title="setModel!=undefined?'Update Account':'Add Account'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" @submit="onSubmit" v-slot="{ errors }" class="floating-labels p-1rem row" ref="form">
                <div class="col-12">
                    <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P1Name'" v-model="model.P1Name" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P1Value'" v-model="model.P1Value" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P2Name'" v-model="model.P2Name" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P2Value'" v-model="model.P2Value" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P3Name'" v-model="model.P3Name" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P3Value'" v-model="model.P3Value" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P4Name'" v-model="model.P4Name" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P4Value'" v-model="model.P4Value" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P5Name'" v-model="model.P5Name" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-sm-6">
                    <formGroup :title="'P5Value'" v-model="model.P5Value" :errors="errors" @keydown.enter="save"></formGroup>
                </div>
                <div class="col-12">
                    <formGroup :title="'Description'" v-model="model.Description" :errors="errors" as="textarea" rows="5" @keydown.enter="save"></formGroup>
                </div>
                
				<!-- <div class="alert alert-danger m-b-15" v-if="errs.status==4">
					<strong>Hata!</strong> Kullanıcı bilgileriniz hatalı. Lütfen kontrol ettikten sonra tekrar deneyiniz.
				</div>
				<div class="alert alert-danger m-b-15" v-if="errs.status!=4 && errs.status>0">
					<strong>Hata!</strong> 
				</div>
                <button type="submit" class="btn btn-success btn-sm bounceIn animation-delay5 login-link pull-right"  :class="{'process':process}" :disabled="process"><b class="fa fa-spinner fa-spin"></b> <span><i class="fas fa-sign-in-alt"></i> Giriş</span></button> -->
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :process="process">{{setModel!=undefined?'Update Account':'Add Account'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            setModel:Object
        },
        data(){
            return{
                model:{
                    Id: null,
                    Name: "",
                    P1Name: "",
                    P2Name: "",
                    P3Name: null,
                    P4Name: null,
                    P5Name: null,
                    P1Value: "",
                    P2Value: "",
                    P3Value: null,
                    P4Value: null,
                    P5Value: null,
                    Description: ""
                },
                errs:{

                },
                process:false
            }
        },
        created(){
            if(this.setModel!=undefined){
                this.model={...this.setModel};
            }
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`Accounts`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"The account has been successfully updated.":"The account has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=undefined){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>